<script setup>
import { useAuthStore } from "~/stores/auth"
import { useAlert } from "~/stores/alert"
import { useVuelidate } from "@vuelidate/core"
import { required, email, helpers } from "@vuelidate/validators"
import { useSettingsStore } from "~/stores/settings"
import ApiService from "~/services/ApiService"

const authStore = useAuthStore()
const { showAlert } = useAlert()
const settingsStore = useSettingsStore()

const settings = settingsStore.settings
const isLoadding = ref(false)

const rules = {
  email: {
    required: helpers.withMessage("Campo obrigatorio", required),
    email: helpers.withMessage("Informe um e-mail valido", email),
  },
}

const v$ = useVuelidate(rules, authStore.form.recover)

async function submit() {
  v$.value.$validate()

  if (!v$.value.$error) {
    try {
      isLoadding.value = true
      const { data } = await ApiService.post("/api/auth/password/email", authStore.form.recover)

      if (data.success) {
        showAlert("success", data.message)
      } else {

        showAlert("error", data.message)
      }
    } catch (err) {
   
      showAlert("error", err.response?.data?.message || "Ocorreu um erro ao processar sua solicitação")
      console.error("Password recovery error:", err)
    } finally {
      isLoadding.value = false
    }
  }
}
</script>

<template>
  <!-- Content -->
  <div class="flex flex-col items-center w-full gap-y-6">
    <!-- Logo -->
    <div class="flex flex-row items-center px-4">

      <div class="flex items-center text-2xl subpixel-antialiased font-extrabold tracking-wider text-white">
        {{ settings.general_site_title }}
      </div>
    </div>


    <!-- Form -->
    <div class="flex flex-col w-full gap-y-4">

      <div class="relative group">
        <p class="text-xs text-brand-primary" v-if="authStore.formErrors.login?.email">{{
            authStore.formErrors.login?.email[0]
          }}</p>

        <BaseInput
            type="email"
            placeholder="Email"
            name="email"
            @keyup.enter="submit"
            v-model="authStore.form.recover.email"
            class="border-red-900 bg-red-600"
            :error="authStore.formErrors.login?.email || v$.email.$errors[0]?.$message"/>
      </div>

      <BaseButton
          @click="submit"
          :loading="isLoadding"
          variant="primary"
      >
        Enviar email de recuperação
      </BaseButton>

      <!-- Register step -->
      <p @click="authStore.modalOpen('register')" class="text-xs font-bold text-center cursor-pointer text-bzMenuText">
        Ainda não tem uma conta? <span class="text-brand-primary hover:text-brighten-brand-primary">Crie uma agora!</span>
      </p>
    </div>
  </div>
</template>